import React from 'react';
export function Logo({
  className = 'w-16 h-16'
}: {
  className?: string;
}) {
  return <img src="https://cdn.magicpatterns.com/uploads/ssv6dqY9BUZrGJQvVn3Xft/Logo.svg" alt="Structured Nutrition"
  // The source mark is light artwork; `brightness-0` renders it solid black.
  className={`${className} brightness-0`} data-id="element-118" data-mp="8stgw2odhln9" />;
}